import { render } from "solid-js/web";
import { App } from "~/solidJs/app/MainApp/index";
import { initSentry } from "~/solidJs/shared/helpers/sentry";

// import "solid-devtools";

// Initialize Sentry for error tracking
initSentry();

render(() => <App />, document.getElementById("app") as HTMLElement);
